import {Button, Card, Checkbox, Form, Icon, Input, InputNumber, Mentions, Spin, Tooltip} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";

import {OptionProps} from "antd/lib/mentions/index";
import {stringify} from "query-string/index";

const {Option, getMentions} = Mentions;
const columns = ['name', 'lastDate', 'location', 'days'];

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      value: "",
    }
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if(match.params && match.params.id) {
      fetch(match.params.id);
    }
    if(this.props.title === "EDIT") {
      this.setState({
        value: this.props.scheduleOptions || "",
        isActive: this.props.data.isActive || false,
      });
      // id = this.props.data.reminderOptions ? this.props.data.reminderOptions.length : 1;
      // console.log(id, this.props.data.reminderOptions);
    }
    if(this.props.title === "CREATE") {
      this.setState({
        value: "* * * * * *",
        isActive: this.props.data.isActive || false
      });
    }
    // this.props.fetchFilter('ManpowerReminder');
  }

  componentWillReceiveProps(nextProps) {
    if(
      nextProps.data &&
      stringify(this.props.data) !== stringify(nextProps.data)
    ) {
      if(this.props.title === "EDIT") {
        this.setState({
          value: nextProps.data.scheduleOptions || "",
          isActive: nextProps.data.isActive || false,
        });
      }
    }
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }
      const data = Object.assign({}, values);
      data.isActive = this.state.isActive;
      // console.log(data);
      if(match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  handleChangeTemplateSubject = (option: OptionProps, prefix: string) => {
    let subject = this.props.form.getFieldValue("template.title");
    // console.log(subject, option);
    let finalString = subject.replace(`@${option.value}`, `{${option.value}}`);
    this.props.form.setFieldsValue({'template.title': finalString});
  };

  handleChangeTemplateBody = (option: OptionProps, prefix: string) => {
    let body = this.props.form.getFieldValue("template.body");
    let finalString = body.replace(`@${option.value}`, `{${option.value}}`);
    this.props.form.setFieldsValue({'template.body': finalString});
  };

  onChangeActive = e => {
    this.setState({
      isActive: e.target.checked
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form} = this.props;
    // let columns = filters &&
    //   Object.keys(filters).filter(filter =>
    //     Boolean(
    //       filters[filter].options &&
    //       filters[filter].type !== "Array" &&
    //       !filters[filter].options.notVisible ||
    //       filters[filter].type !== "ObjectID"
    //     )
    //   );
    // columns = columns.concat(['name', 'date', 'day']);

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if(filters[item].type === 'Array') {
                const field = getFormFieldByType(filters, item, getFieldDecorator, data, {title: title, resource});
                if(item === 'selectedManpowers' && field) {
                  return React.cloneElement(field, {
                    label: "Selected Manpowers (optional)",
                    extra: "This selection is no longer considered. Every manpower with \"Enable Performance Entry Reminder\" checked in the Manpower master is reminded."
                  });
                }
                return field;
              }
              if(filters[item].type === "Boolean") {
                return (
                  <Form.Item key={item} label={"Is Active"}>
                    {getFieldDecorator(item, {
                      // initialValue: data && data[item]
                    })(
                      <Checkbox
                        onChange={this.onChangeActive}
                        checked={this.state.isActive}
                      />
                    )}
                  </Form.Item>
                );
              }
              if(filters[item].type === "Number") {
                return (
                  <Form.Item key={item} label=
                    {<span>Interval Days&nbsp;
                      {filters[item].options.description ?
                        (<Tooltip title={filters[item].options.description}>
                          <Icon type="question-circle-o"/>
                        </Tooltip>) : null}
                    </span>
                    }>
                    {getFieldDecorator(item, {
                      rules: [{
                        required: filters[item].required,
                      }],
                      initialValue: data && data[item] || 0,
                    })(
                      <InputNumber/>
                    )}
                  </Form.Item>
                );
              }
            })}

            <Form.Item key={"defaultReceiverEmail"} label={
              <span>Default Receiver Email&nbsp;
                <Tooltip title="Every reminder is also sent to this email, even if the manpower or supervisor has no linked user account">
                  <Icon type="question-circle-o"/>
                </Tooltip>
              </span>
            }>
              {getFieldDecorator("defaultReceiverEmail", {
                rules: [
                  {required: true, message: "Default Receiver Email is required!"},
                  {type: "email", message: "Please enter a valid email!"}
                ],
                initialValue: data && data["defaultReceiverEmail"]
              })(
                <Input placeholder="Please Enter Default Receiver Email" autoComplete="off"/>
              )}
            </Form.Item>

            <div>
              <div style={{marginTop: "12px"}}>Message Subject/title</div>
              <div
                style={{
                  marginTop: "10px",
                  border: "1px dashed #000",
                  padding: "20px",
                  borderRadius: "9px"
                }}
              >
                <Form.Item
                  key={"title"}
                  labelCol={{span: 6}}
                  wrapperCol={{span: 16}}
                >
                  {getFieldDecorator("template.title", {
                    initialValue:
                    data &&
                    data["template"] &&
                    data["template"]["title"]
                  })(
                    <Mentions
                      rows="4"
                      onSelect={this.handleChangeTemplateSubject}
                      placeholder="Body text, You can use @ to ref schema fields here for the selected module"
                    >
                      {columns &&
                      columns.length &&
                      columns.map((item, index) => (
                        <Option value={item} key={`${item}-${index}`}>{item}</Option>
                      ))}
                    </Mentions>
                  )}
                </Form.Item>
              </div>
            </div>

            <div>
              <div style={{marginTop: "12px"}}>Message Body</div>
              <div
                style={{
                  marginTop: "10px",
                  border: "1px dashed #000",
                  padding: "20px",
                  borderRadius: "9px"
                }}
              >
                <Form.Item
                  key={"body"}
                  labelCol={{span: 6}}
                  wrapperCol={{span: 16}}
                >
                  {getFieldDecorator("template.body", {
                    initialValue:
                    data &&
                    data["template"] &&
                    data["template"]["body"]
                  })(
                    <Mentions
                      rows="4"
                      onSelect={this.handleChangeTemplateBody}
                      placeholder="Body text, You can use @ to ref schema fields here for the selected module"
                    >
                      {columns &&
                      columns.length &&
                      columns.map((item, index) => (
                        <Option value={item} key={`${item}-${index}`}>{item}</Option>
                      ))}
                    </Mentions>
                  )}
                </Form.Item>
              </div>
            </div>

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
